/**
 * Resolve the opaque backend token without reading localStorage/sessionStorage.
 * Prefer in-memory apiClient token. Session JSON must not carry the token.
 */

export async function resolveAuthToken(): Promise<string | null> {
  try {
    const { getApiToken } = await import('@/libs/api/client')
    return getApiToken()
  } catch {
    return null
  }
}
